import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

const ZeyadaFont = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Zeyada&display=swap');
`;

const Wrapper = styled.div`
    position: relative;
    width: 100%;
    height: 300px;
    margin: 2rem 0;
`;

const Card = styled.div`
    position: absolute;
    width: 155px;
    height: 228px;
    background: #f8f5f0;
    padding: 7px 7px 14px 7px;
    border-radius: 3px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.6), 0 2px 8px rgba(0, 0, 0, 0.4);
    cursor: pointer;
`;

const CardImage = styled.div`
    width: 100%;
    height: 85%;
    overflow: hidden;
    background: #d0cac2;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
`;

const CardCaption = styled.div`
    height: 15%;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
        font-family: 'Zeyada', cursive;
        font-size: 13px;
        color: #5a5248;
        margin: 0;
        text-align: center;
        line-height: 1.2;
    }
`;

const photos = [
    {
        src: `${process.env.PUBLIC_URL}/img/Pic3.webp`,
        alt: 'me',
        rotation: -9,
        text: '',
        style: { top: '28px', left: '2%' },
    },
    {
        src: `${process.env.PUBLIC_URL}/img/Pic5.webp`,
        alt: 'run',
        rotation: 2,
        text: '',
        style: { top: '8px', left: 'calc(50% - 77px)' },
    },
    {
        src: `${process.env.PUBLIC_URL}/img/Pic7.webp`,
        alt: 'animal',
        rotation: 13,
        text: '',
        style: { top: '18px', right: '2%' },
    },
];

const PhotoCard = ({ src, alt, rotation, text, index, style }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(
            () => setIsVisible(true),
            600 + index * 280
        );
        return () => clearTimeout(timer);
    }, [index]);

    return (
        <Card
            style={{
                ...style,
                transform: isHovered
                    ? `rotate(${rotation + 2}deg) scale(1.06) translateY(-6px)`
                    : `rotate(${rotation}deg) scale(1)`,
                zIndex: isHovered ? 20 : index + 1,
                opacity: isVisible ? 1 : 0,
                transition: isVisible
                    ? 'transform 0.35s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.5s ease, box-shadow 0.35s ease'
                    : 'opacity 0.5s ease',
                boxShadow: isHovered
                    ? '0 20px 60px rgba(0,0,0,0.7), 0 6px 20px rgba(0,0,0,0.5)'
                    : '0 8px 30px rgba(0,0,0,0.6), 0 2px 8px rgba(0,0,0,0.4)',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <CardImage>
                <img
                    src={src}
                    alt={alt}
                    loading={index === 0 ? 'eager' : 'lazy'}
                    style={{
                        transform: isHovered ? 'scale(1.06)' : 'scale(1)',
                        transition: 'transform 0.35s cubic-bezier(0.23, 1, 0.32, 1)',
                    }}
                />
            </CardImage>
            <CardCaption>
                <p>{text}</p>
            </CardCaption>
        </Card>
    );
};

const PhotoCards = () => (
    <>
        <ZeyadaFont />
        <Wrapper>
            {photos.map((photo, i) => (
                <PhotoCard key={i} {...photo} index={i} />
            ))}
        </Wrapper>
    </>
);

export default PhotoCards;
